import { readRange, readjudgx } from "./xmlreader";
import { QuestionEntity } from "@/util/questionEntity";

const encodetable = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+",
  "/"
];
export function generationExtraction() {
  let code = "";
  const table = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
  ];
  console.log(new Date().getTime());
  for (let i = 0; i < 6; i++) {
    let charNum = Math.floor(Math.random() * 36);
    code += table[charNum];
  }
  return code;
}
/*eslint-disable */
function removePaddingChars(input) {
  let lkey = encodetable.indexOf(input.charAt(input.length - 1));
  if (lkey == 64) {
    return input.substring(0, input.length - 1);
  }
  return input;
}
export function arrayBufferToBase64(buffer, startpos, endpos) {
  if (buffer == null) {
    let erroImage = require("@/assets/image_error.png");
    return erroImage;
  }
  //console.log(startpos+','+endpos)
  let tmpbuffer = buffer.slice(startpos, endpos);
  // console.log(tmpbuffer)

  let array = new Uint8Array(tmpbuffer);
  let length = array.byteLength;

  let base64Str = "data:image/png;base64,";
  let i = 0;
  for (; length - i >= 3; i += 3) {
    let num1 = array[i];
    let num2 = array[i + 1];
    let num3 = array[i + 2];
    base64Str +=
      encodetable[num1 >>> 2] +
      encodetable[((num1 & 0b11) << 4) | (num2 >>> 4)] +
      encodetable[((num2 & 0b1111) << 2) | (num3 >>> 6)] +
      encodetable[num3 & 0b111111];
  }
  let lastByte = length - i;
  if (lastByte === 1) {
    let lastNum1 = array[i];
    base64Str +=
      encodetable[lastNum1 >>> 2] + encodetable[(lastNum1 & 0b11) << 4] + "==";
  } else if (lastByte === 2) {
    let lastNum1 = array[i];
    let lastNum2 = array[i + 1];
    base64Str +=
      encodetable[lastNum1 >>> 2] +
      encodetable[((lastNum1 & 0b11) << 4) | (lastNum2 >>> 4)] +
      encodetable[(lastNum2 & 0b1111) << 2] +
      "=";
  }
  return base64Str;
}

export function base64ToByteArray(inputstr) {
  let array = Buffer.from(inputstr, "base64");
  return array;
}

export function isEmpty(inputstr) {
  if (typeof inputstr == "undefined" || inputstr == null || inputstr == "") {
    return true;
  } else {
    return false;
  }
}

const mojibakePatterns = [
  /浣犵殑/,
  /绛旀/,
  /瑙ｆ瀽/,
  /鍒ゆ柇/,
  /鍗曢€/,
  /澶氶€/,
  /濉┖/,
  /璁＄畻/,
  /璇佹槑/,
  /閫€鍑/,
  /浜ゅ嵎/,
  /鎻愪氦/,
  /铅惧/,
  /爼妫/,
  /嬪垪/,
  /锟/
];

function getMojibakeScore(input) {
  if (typeof input !== "string" || input.length === 0) {
    return 0;
  }
  let score = 0;
  mojibakePatterns.forEach(pattern => {
    if (pattern.test(input)) {
      score += 1;
    }
  });
  return score;
}

function countCjkChar(input) {
  if (typeof input !== "string" || input.length === 0) {
    return 0;
  }
  const match = input.match(/[\u4e00-\u9fff]/g);
  return match ? match.length : 0;
}

function decodeUtf8BytesAsGbk(input) {
  try {
    if (
      typeof TextEncoder === "undefined" ||
      typeof TextDecoder === "undefined"
    ) {
      return input;
    }
    const bytes = new TextEncoder().encode(input);
    return new TextDecoder("gbk").decode(bytes);
  } catch (error) {
    return input;
  }
}

function decodeLatin1AsUtf8(input) {
  try {
    return decodeURIComponent(escape(input));
  } catch (error) {
    return input;
  }
}

function fixMojibakeText(input) {
  if (typeof input !== "string" || input.length === 0) {
    return input;
  }
  if (getMojibakeScore(input) === 0) {
    return input;
  }

  const candidateList = [decodeUtf8BytesAsGbk(input), decodeLatin1AsUtf8(input)];
  let best = input;
  let bestScore = getMojibakeScore(input);
  let bestCjkCount = countCjkChar(input);

  candidateList.forEach(candidate => {
    if (typeof candidate !== "string" || candidate.length === 0) {
      return;
    }
    const candidateScore = getMojibakeScore(candidate);
    const candidateCjkCount = countCjkChar(candidate);
    const isBetterScore = candidateScore < bestScore;
    const isBetterCjk = candidateScore === bestScore && candidateCjkCount > bestCjkCount;
    if (isBetterScore || isBetterCjk) {
      best = candidate;
      bestScore = candidateScore;
      bestCjkCount = candidateCjkCount;
    }
  });

  return best;
}

function normalizeRangeWordInfos(rangeList) {
  if (!Array.isArray(rangeList)) {
    return;
  }
  rangeList.forEach(rangeInfo => {
    if (!rangeInfo || !Array.isArray(rangeInfo.wordInfos)) {
      return;
    }
    rangeInfo.wordInfos.forEach(wordInfo => {
      if (!wordInfo || typeof wordInfo.content !== "string") {
        return;
      }
      wordInfo.content = fixMojibakeText(wordInfo.content);
    });
  });
}

function normalizeQuestionText(question) {
  if (!question) {
    return;
  }
  normalizeRangeWordInfos(question.steam);
  normalizeRangeWordInfos(question.solve);
  normalizeRangeWordInfos(question.slove);
  normalizeRangeWordInfos(question.fill);
  normalizeRangeWordInfos(question.answerjs);
  if (Array.isArray(question.options)) {
    question.options.forEach(option => {
      if (!option || !Array.isArray(option.ranginfos)) {
        return;
      }
      normalizeRangeWordInfos(option.ranginfos);
    });
  }
}

function generationRangInfo(answer) {
  let rg = {
    index: 0, wordInfos: [{
      wdType: 0,
      startpos: 1,
      imgstartpos: 0,
      imglen: 0,
      haslatex: true,
      latex: "",
      content: answer
    }]
  }
  return rg;
}
export function convertToQustionEntity(tmpquestion) {
  const optioncodes = "ABCDEFGHIGKLMNOPQRSTUVWXYZ";
  let ntmp = new QuestionEntity()
  ntmp.score = tmpquestion.score;
  ntmp.haslatex = tmpquestion.hasLatex;
  ntmp.id = tmpquestion.id;
  ntmp.qtype = tmpquestion.qtype;
  ntmp.knowledgeSerialnumber = tmpquestion.knowledgeID;
  ntmp.level = tmpquestion.level;
  ntmp.correctOrder = [];
  ntmp.steamjs = JSON.parse(tmpquestion.steamjs)
  ntmp.slove = []
  //ntmp.answerjs=JSON.parse(tmpquestion.answerjs)
  if (isEmpty(tmpquestion.solvejs)) {
    ntmp.solvejs = []
    console.log(tmpquestion)
  }
  else {
    ntmp.solvejs = JSON.parse(tmpquestion.solvejs)
  }
  ntmp.optionsjs = [];
  if (isEmpty(tmpquestion.steambuffer)) {
    tmpquestion.steambuffer = new Uint8Array();
  } else {
    tmpquestion.steambuffer = base64ToByteArray(tmpquestion.steambuffer);
  }
  if (isEmpty(tmpquestion.solvebuffer)) {
    tmpquestion.solvebuffer = new Uint8Array();
  } else {
    tmpquestion.solvebuffer = base64ToByteArray(tmpquestion.solvebuffer);
  }

  if (isEmpty(tmpquestion.answerbuffer)) {
    tmpquestion.answerbuffer = new Uint8Array();
  } else {
    tmpquestion.answerbuffer = base64ToByteArray(tmpquestion.answerbuffer);
  }
  //steamjs
  for (let index = 0; index < ntmp.steamjs.length; index++) {
    let raginfo = ntmp.steamjs[index];
    for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
      let rag = raginfo.wordInfos[wdindex];
      if (rag.wdType === 1 && rag.haslatex === false) {
        rag.wdType = 2;
        //console.log(rag)
        rag.buffer = arrayBufferToBase64(
          tmpquestion.steambuffer,
          rag.imgstartpos,
          rag.imgstartpos + rag.imglen
        );
        raginfo.wordInfos[wdindex] = rag;

      }
    }
  }

  //solve
  for (let index = 0; index < ntmp.solvejs.length; index++) {
    let raginfo = ntmp.solvejs[index];
    for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
      let rag = raginfo.wordInfos[wdindex];
      if (rag.wdType === 1 && rag.haslatex === false) {
        rag.wdType = 2;
        //console.log(rag)
        rag.buffer = arrayBufferToBase64(
          tmpquestion.solvebuffer,
          rag.imgstartpos,
          rag.imgstartpos + rag.imglen
        );
        raginfo.wordInfos[wdindex] = rag;

        ntmp.slove.push(raginfo);
      }
    }
  }
  //judge
  if (tmpquestion.qtype === "JudgX" || tmpquestion.questionType === "JudgX") {
    ntmp.answerjs = []
    let jgx = JSON.parse(tmpquestion.answerjs);
    if (jgx.judge) {
      ntmp.answerjs.push(generationRangInfo("【正确】"))
    } else {
      ntmp.answerjs.push(generationRangInfo("【错误】"))
    }
  }
  //选择题
  let tmpoptions = []
  if (tmpquestion.qtype === "SingX" || tmpquestion.qtype === "MultX") {
    tmpoptions = JSON.parse(tmpquestion.answerjs)

    // console.log(ntmp.options)
    for (let index = 0; index < tmpoptions.length; index++) {
      let opitem = tmpoptions[index];
      for (let i = 0; i < opitem.ranginfos.length; i++) {
        let raginfo = opitem.ranginfos[i];
        for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
          let rag = raginfo.wordInfos[wdindex];
          if (rag.wdType === 1 && rag.haslatex === false) {
            rag.wdType = 2;
            rag.buffer = arrayBufferToBase64(
              tmpquestion.answerbuffer,
              rag.imgstartpos,
              rag.imgstartpos + rag.imglen
            );
            raginfo.wordInfos[wdindex] = rag;
          }
        }
      }
      tmpoptions[index] = opitem;
    }
    if (!isEmpty(tmpquestion.order)) {
      let fixindex = tmpquestion.order.split(',')
      fixindex.forEach(fixidex => {
        let fixid = parseInt(fixidex)
        ntmp.optionsjs.push(tmpoptions[fixid])
      });
    }
    let correctanswer = ''
    ntmp.optionsjs.forEach((opt, pidx) => {
      if (opt.correct) {
        correctanswer = correctanswer + optioncodes[pidx] + ',';
      }
    })
    ntmp.answerjs = []
    if (correctanswer.length > 1) {
      correctanswer = '【' + correctanswer.slice(0, correctanswer.length - 1) + '】';
      ntmp.answerjs.push(generationRangInfo(correctanswer));
    }
  }
  //填空题
  if (tmpquestion.qtype === "FillX" || tmpquestion.questionType === "FillX") {
    ntmp.answerjs = JSON.parse(tmpquestion.answerjs)
    for (let index = 0; index < ntmp.answerjs.length; index++) {
      let raginfo = ntmp.answerjs[index];
      for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
        let rag = raginfo.wordInfos[wdindex];
        if (rag.wdType === 1 && rag.haslatex === false) {
          rag.wdType = 2;
          rag.buffer = arrayBufferToBase64(
            tmpquestion.answerbuffer,
            rag.imgstartpos,
            rag.imgstartpos + rag.imglen
          );
          raginfo.wordInfos[wdindex] = rag;
        }
      }
    }
  }
  normalizeQuestionText(ntmp);
  return ntmp;
}




//解析返回的数据,传入的返回的数组里面的每一项
export function convertToFullQuestion(tmpquestion, onlyStem = false) {
  // console.log(tmpquestion);

  let ntmp = { tmpquestion };
  ntmp.id = tmpquestion.id;
  ntmp.usr_choice = tmpquestion.usr_choice;
  ntmp.order = tmpquestion.order;
  ntmp.qid = tmpquestion.questionId;
  ntmp.knowledgeID = tmpquestion.knowledgeID;
  ntmp.subjectType = tmpquestion.qtype || tmpquestion.questionType;
  ntmp.level = tmpquestion.level;
  ntmp.score = tmpquestion.score;
  ntmp.serialnumber = tmpquestion.knowledgeID + tmpquestion.qID;
  ntmp.correctOrder = [];
  // console.log(ntmp)
  if (tmpquestion.solveJs == undefined) {
    if (!onlyStem) ntmp.solve = JSON.parse(tmpquestion.solvejs)
  } else {
    if (!onlyStem) ntmp.solve = JSON.parse(tmpquestion.solveJs)
  }

  if (isEmpty(tmpquestion.steambuffer)) {
    tmpquestion.steambuffer = new Uint8Array();
  } else {
    tmpquestion.steambuffer = base64ToByteArray(tmpquestion.steambuffer);
  }

  if (!onlyStem) {
    if (isEmpty(tmpquestion.solvebuffer)) {
      tmpquestion.solvebuffer = new Uint8Array();
    } else {
      tmpquestion.solvebuffer = base64ToByteArray(tmpquestion.solvebuffer);
    }

    if (isEmpty(tmpquestion.answerbuffer)) {
      tmpquestion.answerbuffer = new Uint8Array();
    } else {
      tmpquestion.answerbuffer = base64ToByteArray(tmpquestion.answerbuffer);
    }
  }

  if (tmpquestion.steamjs == undefined) {
    if (isEmpty(tmpquestion.stemJs)) {
      ntmp.steam = readRange(tmpquestion.steam);
    } else {
      ntmp.steam = JSON.parse(tmpquestion.stemJs);
    }
  } else {
    if (isEmpty(tmpquestion.steamjs)) {
      ntmp.steam = readRange(tmpquestion.steam);
    } else {
      ntmp.steam = JSON.parse(tmpquestion.steamjs);
    }
  }

  // 始终只对必须的 buffer 进行处理
  // 注意：tmpquestion 是引用的原对象，如果 onlyStem 为 true，下次全量加载时可能会有 buffer 为空的问题吗？
  // convertToFullQuestion 返回的是 ntmp，tmpquestion 是传入对象。这里直接修改 tmpquestion 可能会有副作用，
  // 但原逻辑就是这样改的。考虑到列表数据和详情数据通常是分离的，或者是新生成的对象，应该没问题。

  //处理题干（必须）
  for (let index = 0; index < ntmp.steam.length; index++) {
    let raginfo = ntmp.steam[index];
    for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
      let rag = raginfo.wordInfos[wdindex];
      if (rag.wdType === 1 && rag.haslatex === false) {
        rag.wdType = 2;
        //console.log(rag)
        rag.buffer = arrayBufferToBase64(
          tmpquestion.steambuffer,
          rag.imgstartpos,
          rag.imgstartpos + rag.imglen
        );
        raginfo.wordInfos[wdindex] = rag;

      }
    }
  }

  // --- 如果仅需题干，直接返回 ---
  if (onlyStem) {
    // 简单初始化其他字段为空数组以防报错
    ntmp.slove = [];
    ntmp.fill = [];
    ntmp.options = [];
    ntmp.hasslove = false;
    ntmp.hasjudge = false;
    ntmp.hasops = false;
    ntmp.hasfill = false;
    ntmp.qtypename = "";

    // 简单判断下题型名称用于显示
    if (tmpquestion.qtype === "JudgX" || tmpquestion.questionType === "JudgX") ntmp.qtypename = "判断题";
    if (tmpquestion.qtype === "SingX" || tmpquestion.questionType === "SingX") ntmp.qtypename = "单选题";
    if (tmpquestion.qtype === "MultX" || tmpquestion.questionType === "MultX") ntmp.qtypename = "多选题";
    if (tmpquestion.qtype === "FillX" || tmpquestion.questionType === "FillX") ntmp.qtypename = "填空题";
    if (tmpquestion.qtype === "AnwsX" || tmpquestion.questionType === "AnwsX") ntmp.qtypename = "解答题";
    if (tmpquestion.qtype === "ProofX" || tmpquestion.questionType === "ProofX") ntmp.qtypename = "证明题";

    normalizeQuestionText(ntmp);
    return ntmp;
  }
  // ------------------------------

  ntmp.slove = [];
  for (let index = 0; index < ntmp.solve.length; index++) {
    let raginfo = ntmp.solve[index];
    for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
      let rag = raginfo.wordInfos[wdindex];
      if (rag.wdType === 1 && rag.haslatex === false) {
        rag.wdType = 2;
        //console.log(rag)
        rag.buffer = arrayBufferToBase64(
          tmpquestion.solvebuffer,
          rag.imgstartpos,
          rag.imgstartpos + rag.imglen
        );
        raginfo.wordInfos[wdindex] = rag;

        ntmp.slove.push(raginfo);
      }
    }
  }

  ntmp.fill = [];
  ntmp.options = [];

  ntmp.hasslove = false;

  ntmp.hasjudge = false;
  if (tmpquestion.qtype === "JudgX" || tmpquestion.questionType === "JudgX") {
    //console.log(tmpquestion);
    ntmp.qtypename = "判断题";
    ntmp.hasjudge = true;
    if (isEmpty(tmpquestion.answerjs || tmpquestion.answerJs)) {
      let jgbr = readjudgx(tmpquestion.answer);
      if (jgbr[0] && jgbr[0].judgx) {
        ntmp.judge = 1;
      } else {
        ntmp.judge = 0;
      }
    } else {
      let jgx = JSON.parse(tmpquestion.answerjs || tmpquestion.answerJs);
      if (jgx.judge) {
        ntmp.judge = 1;
      } else {
        ntmp.judge = 0;
      }
    }
  }
  ntmp.hasops = false;
  if (tmpquestion.qtype === "SingX" || tmpquestion.questionType === "SingX") {
    ntmp.qtypename = "单选题";
    // if (this.showmode === 2) {
    ntmp.hasops = true;
    if (tmpquestion.answerjs == undefined) {
      if (isEmpty(tmpquestion.answerJs)) {
        ntmp.options = readoption(tmpquestion.answer)
      }
      else {
        ntmp.options = JSON.parse(tmpquestion.answerJs)
      }
    } else {
      if (isEmpty(tmpquestion.answerjs)) {
        ntmp.options = readoption(tmpquestion.answer)
      }
      else {
        ntmp.options = JSON.parse(tmpquestion.answerjs)
      }
    }
    // console.log(ntmp.options)
    for (let index = 0; index < ntmp.options.length; index++) {
      let opitem = ntmp.options[index];
      for (let i = 0; i < opitem.ranginfos.length; i++) {
        let raginfo = opitem.ranginfos[i];
        for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
          let rag = raginfo.wordInfos[wdindex];
          if (rag.wdType === 1 && rag.haslatex === false) {
            rag.wdType = 2;
            rag.buffer = arrayBufferToBase64(
              tmpquestion.answerbuffer,
              rag.imgstartpos,
              rag.imgstartpos + rag.imglen
            );
            raginfo.wordInfos[wdindex] = rag;
          }
        }
      }
      opitem.index = index;
      ntmp.options[index] = opitem;
    }
    let fixoptions = []
    if (tmpquestion.order == '' || tmpquestion.order == undefined) {
      let fixorder = ''
      let rid = Math.floor(Math.random() * ntmp.options.length);
      fixorder += rid
      let fixindex = []
      fixindex.push(rid)
      for (let i = 0; i < ntmp.options.length; i++) {
        if (i !== rid) {
          fixindex.push(i)
          fixorder += ','
          fixorder += i
        }
      }
      ntmp.order = fixorder
      fixindex.forEach(fixidex => {
        fixoptions.push(ntmp.options[fixidex])
      });
    }
    else {
      let fixindex = [];
      if (typeof tmpquestion.order === "string") {
        if (tmpquestion.order.indexOf("[") !== -1) {
          try {
            let parsed = JSON.parse(tmpquestion.order);
            if (Array.isArray(parsed)) {
              fixindex = parsed;
            } else {
              fixindex = tmpquestion.order.split(",");
            }
          } catch (e) {
            fixindex = tmpquestion.order.split(",");
          }
        } else {
          fixindex = tmpquestion.order.split(",");
        }
      } else if (Array.isArray(tmpquestion.order)) {
        fixindex = tmpquestion.order;
      }

      fixindex.forEach(fixidex => {
        let fixid = parseInt(fixidex);
        if (!isNaN(fixid) && ntmp.options[fixid]) {
          fixoptions.push(ntmp.options[fixid]);
        }
      });
    }

    ntmp.options = fixoptions
    // }
  }
  if (tmpquestion.qtype === "MultX" || tmpquestion.questionType === "MultX") {
    ntmp.qtypename = "多选题";
    // if (this.showmode === 2) {
    if (tmpquestion.answerjs == undefined) {
      if (isEmpty(tmpquestion.answerJs)) {
        ntmp.options = readoption(tmpquestion.answer)
      }
      else {
        ntmp.options = JSON.parse(tmpquestion.answerJs)
      }
    } else {
      if (isEmpty(tmpquestion.answerjs)) {
        ntmp.options = readoption(tmpquestion.answer)
      }
      else {
        ntmp.options = JSON.parse(tmpquestion.answerjs)
      }
    }
    for (let index = 0; index < ntmp.options.length; index++) {
      // console.log(ntmp.options);
      let opitem = ntmp.options[index];
      for (let i = 0; i < opitem.ranginfos.length; i++) {
        let raginfo = opitem.ranginfos[i];
        for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
          let rag = raginfo.wordInfos[wdindex];
          if (rag.wdType === 1) {
            let rag = raginfo.wordInfos[wdindex];
            if (rag.wdType === 1 && rag.haslatex === false) {
              rag.wdType = 2;
              rag.buffer = arrayBufferToBase64(
                tmpquestion.answerbuffer,
                rag.imgstartpos,
                rag.imgstartpos + rag.imglen
              );
              raginfo.wordInfos[wdindex] = rag;
            }
            raginfo.wordInfos[wdindex] = rag;
          }
        }
      }
      opitem.index = index;
      ntmp.options[index] = opitem;
    }
    let fixoptions = []
    if (tmpquestion.order == '' || tmpquestion.order == undefined) {
      let fixorder = ''
      let rid = Math.floor(Math.random() * ntmp.options.length);
      fixorder += rid
      let fixindex = []
      fixindex.push(rid)
      for (let i = 0; i < ntmp.options.length; i++) {
        if (i !== rid) {
          fixindex.push(i)
          fixorder += ','
          fixorder += i
        }
      }
      ntmp.order = fixorder
      fixindex.forEach(fixidex => {
        fixoptions.push(ntmp.options[fixidex])
      });
    } else {
      let fixindex = tmpquestion.order.split(',')
      fixindex.forEach(fixidex => {
        let fixid = parseInt(fixidex)
        fixoptions.push(ntmp.options[fixid])
      });
      ntmp.options = fixoptions
    }

    // }
  }
  ntmp.hasfill = false;
  if (tmpquestion.qtype === "FillX" || tmpquestion.questionType === "FillX") {
    ntmp.qtypename = "填空题";
    // if (this.showmode === 2) {
    ntmp.hasfill = true;
    if (isEmpty(tmpquestion.answerjs || tmpquestion.answerJs)) {
      ntmp.fill = readRange(tmpquestion.answer);
    } else {
      ntmp.fill = JSON.parse(tmpquestion.answerJs || tmpquestion.answerjs)
    }
    for (let index = 0; index < ntmp.fill.length; index++) {
      let raginfo = ntmp.fill[index];
      for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
        let rag = raginfo.wordInfos[wdindex];
        if (rag.wdType === 1 && rag.haslatex === false) {
          rag.wdType = 2;
          rag.buffer = arrayBufferToBase64(
            tmpquestion.answerbuffer,
            rag.imgstartpos,
            rag.imgstartpos + rag.imglen
          );
          raginfo.wordInfos[wdindex] = rag;
        }
      }
    }
    // }
  }
  if (tmpquestion.qtype === "AnwsX" || tmpquestion.questionType === "AnwsX") {
    ntmp.qtypename = "解答题";

  }
  if (tmpquestion.qtype === "ProofX" || tmpquestion.questionType === "ProofX") {
    ntmp.qtypename = "证明题";
  }
  if (tmpquestion.qtype === "All" || tmpquestion.questionType === "All") {
    ntmp.qtypename = "全题型";
  }
  normalizeQuestionText(ntmp);
  //console.log(ntmp)
  return ntmp;
}
